const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/127\.\d+\.\d+\.\d+/)
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }

    // ✅ Only enable version polling in production mode
    if (process.env.NODE_ENV === 'production') {
      // 🔁 Poll for version changes every minute
      setInterval(() => {
        fetch(`${process.env.PUBLIC_URL}/version.js?ts=${Date.now()}`)
          .then((res) => res.text())
          .then((code) => {
            const match = code.match(/window\.BUILD_HASH='(.*)'/);
            if (match && match[1] && match[1] !== window.BUILD_HASH) {
              console.log('🔁 New version detected, reloading...');
              window.location.reload(true);
            }
          })
          .catch(() => {
            console.log('Version check failed. Possibly offline.');
          });
      }, 60000); // Check every 60 seconds
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New content is available; reloading silently...');
              registration.waiting?.postMessage({ type: 'SKIP_WAITING' });

              navigator.serviceWorker.addEventListener('controllerchange', () => {
                window.location.reload(); // Auto reload
              });
            } else {
              console.log('Content is cached for offline use.');
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl)
    .then((response) => {
      const isInvalid =
        response.status === 404 || !response.headers.get('content-type')?.includes('javascript');

      if (isInvalid) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}
